import { DrawFrontDrawer } from './DrawFrontDrawer';

export class DrawFrontPullOut extends DrawFrontDrawer {

}
